export const lightColors = {
  primary: '#2563eb',
  primaryLight: '#3b82f6',
  primaryDark: '#1e40af',
  primaryContainer: '#dbeafe',
  onPrimary: '#ffffff',
  onPrimaryContainer: '#1e3a8a',
  secondary: '#7c3aed',
  secondaryLight: '#8b5cf6',
  secondaryDark: '#5b21b6',
  secondaryContainer: '#ede9fe',
  onSecondary: '#ffffff',
  onSecondaryContainer: '#4c1d95',
  success: '#16a34a',
  warning: '#ea580c',
  error: '#dc2626',
  background: '#f8fafc',
  backgroundElevated: '#ffffff',
  surface: '#ffffff',
  surfaceVariant: '#f1f5f9',
  onBackground: '#0f172a',
  onSurface: '#1e293b',
  text: '#0f172a',
  textSecondary: '#64748b',
  textTertiary: '#94a3b8',
  border: '#e2e8f0',
  borderLight: '#f1f5f9',
  outline: '#cbd5e1',
  overlay: 'rgba(0, 0, 0, 0.5)',
  backdrop: 'rgba(0, 0, 0, 0.3)',
  card: '#ffffff',
};

export const darkColors = {
  primary: '#8b5cf6',
  primaryLight: '#a78bfa',
  primaryDark: '#6d28d9',
  primaryContainer: '#2e1065',
  onPrimary: '#f8fafc',
  onPrimaryContainer: '#f5f3ff',
  secondary: '#f59e0b',
  secondaryLight: '#fbbf24',
  secondaryDark: '#b45309',
  secondaryContainer: '#451a03',
  onSecondary: '#1f1300',
  onSecondaryContainer: '#fffbeb',
  success: '#4ade80',
  warning: '#fb923c',
  error: '#f87171',
  background: '#06020f',
  backgroundElevated: '#0f0a1f',
  surface: '#0f0a1f',
  surfaceVariant: '#1a1330',
  onBackground: '#f8fafc',
  onSurface: '#e2e8f0',
  text: '#f8fafc',
  textSecondary: '#c7b8ea',
  textTertiary: '#9b90c5',
  border: '#241a3f',
  borderLight: '#342756',
  outline: '#433469',
  overlay: 'rgba(6, 2, 16, 0.7)',
  backdrop: 'rgba(6, 2, 16, 0.6)',
  card: '#120b24',
};

// Fixed visual-effect primitives shared by CSS strings and React inline styles.
// Theme colors above stay semantic; these values describe alpha/glow treatments.
export const landingEffectColors = {
  'color-transparent': 'transparent',
  'color-white': '#ffffff',
  'color-c9b8f0': '#c9b8f0',
  'color-dbeafe': '#dbeafe',
  'color-e2e8f0': '#e2e8f0',
  'color-black-a-10': 'rgba(0,0,0,0.10)',
  'color-black-a-12': 'rgba(0,0,0,0.12)',
  'color-black-a-18': 'rgba(0,0,0,0.18)',
  'color-black-a-35': 'rgba(0,0,0,0.35)',
  'color-black-a-45': 'rgba(0,0,0,0.45)',
  'color-black-a-55': 'rgba(0,0,0,0.55)',
  'color-black-a-70': 'rgba(0,0,0,0.7)',
  'color-rgba-15-23-42-85': 'rgba(15,23,42,0.85)',
  'color-rgba-17-24-39-35': 'rgba(17,24,39,0.35)',
  'color-rgba-52-211-153-10': 'rgba(52,211,153,0.10)',
  'color-rgba-52-211-153-16': 'rgba(52,211,153,0.16)',
  'color-rgba-59-130-246-8': 'rgba(59,130,246,0.08)',
  'color-rgba-59-130-246-10': 'rgba(59,130,246,0.1)',
  'color-rgba-59-130-246-16': 'rgba(59,130,246,0.16)',
  'color-rgba-59-130-246-25': 'rgba(59,130,246,0.25)',
  'color-rgba-109-40-217-26': 'rgba(109,40,217,0.26)',
  'color-rgba-109-40-217-40': 'rgba(109,40,217,0.4)',
  'color-rgba-124-58-237-12': 'rgba(124,58,237,0.12)',
  'color-rgba-139-92-246-8': 'rgba(139,92,246,0.08)',
  'color-rgba-139-92-246-12': 'rgba(139,92,246,0.12)',
  'color-rgba-139-92-246-30': 'rgba(139,92,246,0.30)',
  'color-rgba-139-92-246-45': 'rgba(139,92,246,0.45)',
  'color-rgba-245-158-11-20': 'rgba(245,158,11,0.20)',
  'color-white-a-3': 'rgba(255,255,255,0.03)',
  'color-white-a-3-5': 'rgba(255,255,255,0.035)',
  'color-white-a-4': 'rgba(255,255,255,0.04)',
  'color-white-a-5': 'rgba(255,255,255,0.05)',
  'color-white-a-6': 'rgba(255,255,255,0.06)',
  'color-white-a-8': 'rgba(255,255,255,0.08)',
  'color-white-a-10': 'rgba(255,255,255,0.1)',
  'color-white-a-12': 'rgba(255,255,255,0.12)',
  'color-white-a-14': 'rgba(255,255,255,0.14)',
  'color-white-a-15': 'rgba(255,255,255,0.15)',
  'color-white-a-16': 'rgba(255,255,255,0.16)',
  'color-white-a-18': 'rgba(255,255,255,0.18)',
  'color-white-a-20': 'rgba(255,255,255,0.2)',
  'color-white-a-22': 'rgba(255,255,255,0.22)',
} as const;

export type LandingTheme = typeof lightColors;

export const getLandingColors = (isDark: boolean): LandingTheme => {
  return isDark ? darkColors : lightColors;
};
